import { Search } from '@app/components/various/Search';
import { Sortable } from '@app/components/various/Sortable';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { Sortable as SortableTypes } from '@typings';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ProductsList.module.scss';

interface Props {
  listText: JSX.Element | string;
  disableSort?: boolean;
  searchPhrase: string;
  items: string[];
  renderFunction: (property: string) => JSX.Element;
  onSearchChange: (value: string) => void;
  onSortEnd: (sortedArray: string[]) => void;
}

export const ProductsList = ({ listText, searchPhrase, onSearchChange, disableSort = false, items, renderFunction, onSortEnd }: Props) => {
  const { t } = useTranslation(['cms', 'common']);
  const noSearchResults = isEmpty(items) && !isEmpty(searchPhrase);

  const isDisabled = disableSort || !isDefined(searchPhrase) || !isEmpty(searchPhrase);

  const sortableItems = React.useMemo(() => items.map(id => ({ id })), [items]);

  const handleSortEnd = (newItems: SortableTypes.Items<string>) => {
    onSortEnd(newItems.map(({ id }) => id));
  };

  return (
    <div className={styles.listWrapper}>
      <p className={styles.listText}>{listText}</p>
      <div className={styles.lazyProductsList}>
        <Search placeholder={t('cms:search_for_products')} value={searchPhrase} onChange={onSearchChange} isFluid />
        {noSearchResults ?
          <div className="p-12 text-center">{t('common:no_results')}</div>
        : <div className="overflow-auto">
            <Sortable
              isDisabled={isDisabled}
              items={sortableItems}
              renderItem={renderFunction}
              dragMode="handle"
              onSortEnd={handleSortEnd}
            />
          </div>
        }
      </div>
    </div>
  );
};
